import { environment } from "src/environments/environment";
import { IAuditableEntity, IEntityBase } from "../shared/models";

export const OPERATION_ODATA_URL = `${environment.baseOdataUrl}/Operations`;
export const SCHEDULE_JOB_ODATA_URL = `${environment.baseOdataUrl}/ScheduleJobs`;
export const WORKSTATION_ODATA_URL = `${environment.baseOdataUrl}/WorkStations`;
export const CHECKSHEET_ODATA_URL = `${environment.baseOdataUrl}/Checksheets`;
export const WORKSTATION_STATUS_ODATA_URL = `${environment.baseOdataUrl}/WorkStationStatuses`;
export const PROCESS_ODATA_URL = `${environment.baseOdataUrl}/Processes`;
export const PART_ODATA_URL = `${environment.baseOdataUrl}/Parts`;
export const JOB_ODATA_URL = `${environment.baseOdataUrl}/Jobs`;
export const ROUTING_ODATA_URL = `${environment.baseOdataUrl}/Routings`;
export const PROCESS_ROUTING_ODATA_URL = `${environment.baseOdataUrl}/ProcessRoutings`;
export const PROCESS_INPUT_ODATA_URL = `${environment.baseOdataUrl}/ProcessInputs`;
export const PROCESS_ROUTING_STEP_ODATA_URL = `${environment.baseOdataUrl}/ProcessRoutingSteps`;
export const ORDERS_ODATA_URL = `${environment.baseOdataUrl}/Orders`;
export const ORDERS_LINES_ODATA_URL = `${environment.baseOdataUrl}/OrderLines`;
export const EMPLOYEE_ODATA_URL = `${environment.baseOdataUrl}/Employees`;
export const SHIFT_STATUS_ODATA_URL = `${environment.baseOdataUrl}/ShiftStatuses`;
export const SHIFT_ODATA_URL = `${environment.baseOdataUrl}/Shifts`;
export const SHIFT_EMPLOYEE_ODATA_URL = `${environment.baseOdataUrl}/ShiftEmployees`;
export const SHIFT_INTERVAL_ODATA_URL = `${environment.baseOdataUrl}/ShiftIntervals`;
export const UNIT_OF_MEASURE_ODATA_URL = `${environment.baseOdataUrl}/UnitOfMeasures`;
export const MAINTENANCE_STATUS_ODATA_URL = `${environment.baseOdataUrl}/MaintenanceStatuses`;
export const MAINTENANCE_ODATA_URL =  `${environment.baseOdataUrl}/Maintenances`;
export const MAINTENANCE_TYPE_ODATA_URL =  `${environment.baseOdataUrl}/MaintenanceTypes`;
export const WEEK_OFF_POLICY_ODATA_URL = `${environment.baseOdataUrl}/WeekOffPolicies`;
export const PRODUCTION_ORDER_STATUS_ODATA_URL = `${environment.baseOdataUrl}/ProductionOrderStatuses`;
export const DOWN_TIME_CODE_ODATA_URL = `${environment.baseOdataUrl}/DownTimeCodes`;
export const SERIAL_NUMBER_CONFIGURATION_ODATA_URL = `${environment.baseOdataUrl}/SerialNumberConfigurations`;
export const SERIAL_NUMBER_ODATA_URL = `${environment.baseOdataUrl}/SerialNumbers`;
export const BATCH_NUMBER_ODATA_URL = `${environment.baseOdataUrl}/BatchNumbers`;
export const WORKSTATIONGROUP_ODATA_URL = `${environment.baseOdataUrl}/WorkStationGroups`;
export const PRODUCTIONORDER_ODATA_URL = `${environment.baseOdataUrl}/ProductionOrders`
export const PROJECT_ODATA_URL = `${environment.baseOdataUrl}/Projects`;
export interface IProcessFilter {
  OperationId:number |null,
  WorkStationId:number |null,
  WorkStationGroupId:number |null
}
export interface IProcessRoutingFilter  {
  PartId:number | null,
  OperationId:number | null,
}

export interface IProcess extends IEntityBase, IAuditableEntity {
  OperationId: number | null,
  WorkStationId: number | null,
  WorkStationGroupId: number | null
}

export interface IProcessInput extends IEntityBase, IAuditableEntity {
  PartId:number | null,
  OperationId:number | null,
 }

 export interface IProcessInputDetail extends IEntityBase, IAuditableEntity {
  ProcessInputId?:number,
  PartId: number | null,
  Quantity:null,
  UnitOfMeasureId: number | null,
  ProcessRoutingId?:null
}

export interface IProcessOutputDetail extends IEntityBase, IAuditableEntity {
  ProcessOutputId?:number,
  PartId: number | null,
  Quantity:number | null,
  UnitOfMeasureId: number | null,
}

export interface IProcessRouting extends IEntityBase, IAuditableEntity {

  PartId:null,
  OperationId: null,
  SetupTime: null,
  SetupTimePeriodTypeId: number | null,
  CycleTime: null,
  CycleTimePeriodTypeId: number | null,
}

export interface IProcessOutput extends IEntityBase, IAuditableEntity {
  PartId: null,
  Quantity: string,
  UnitOfMeasureId: null
}

export interface IControlPanelOrder extends IEntityBase, IAuditableEntity {
  OrderId:number |null,
  PartId:number |null,
}

export interface IControlPanelConfiguration extends IEntityBase, IAuditableEntity {
  WorkStationId: number,
  OperationId: number,
  OperatorId: number,
  OrderId: number,
  PartId: number,
  Count : number
}

export interface IControlPanelPart extends IEntityBase, IAuditableEntity {
  PartId: null,
  PartCategoryId: null,
}

export interface IControlPanelRecord extends IEntityBase, IAuditableEntity {
  Quantity: null,
  UnitOfMeasureId: number| null,
}
export interface IProcessRoutingDetail extends IEntityBase, IAuditableEntity {
  PartId:number | null,
  OperationId:number | null,
  SetupTime: null,
  CycleTime: null,
 }

 export interface IProcessRoutingTool extends IEntityBase, IAuditableEntity {
  Id?:number,
  ToolId: number |null,
  Quantity:number |null,
  UnitOfMeasureId: number | null,
  Instructions:string
}

export interface IProcessRoutingStep extends IEntityBase, IAuditableEntity {
  Id?:number,
  Name:string,
  SetupTime: number | null,
  CycleTime: number | null,
  Instructions:string,
  CycleTimePeriodTypeId: number | null,
  SetupTimePeriodTypeId: number | null,
}

export interface IProcessRoutingStepAttachment {
  Id?: number,
  Name: string,
  Description: string,
  IsDefault: boolean,
}

export interface IProcessRoutingStepTool extends IEntityBase, IAuditableEntity {
  Id?:number,
  ToolId:number |null,
  Quantity: number,
  UnitOfMeasureId:number | null,
  Instructions:string
}

export interface IProcessRoutingStepDetail extends IEntityBase, IAuditableEntity{
  Name:string,
  SetupTimePeriodTypeId:null,
  CycleTimePeriodTypeId:null,
  SetupTime:null,
  CycleTime:null,
  Instructions:string,
 }

export interface IShiftFilter {
  Name : string,   
}

export interface IShift {
  Id? : number,
  Name : string,
  ShiftCode : string,
  Description : string,
  StartTime : Date | any,
  EndTime : Date | any,
  WeekOffPolicyId: number | null
}

export interface IShiftEmployeeFilter {
  ShiftId : number | any,
  ShiftStatusId : number | any,
  EmployeeId : number | any,    
}

export interface IShiftEmployee {
  Id? : number,
  ShiftId : number | any,
  EmployeeId : number | any,
  StartTime : string,
  EndTime : string,
  ShiftStatusId : number | any,
}

export interface IOperationFilter  {
  Name: string
}

export interface IOperation extends IEntityBase,IAuditableEntity {
  Id? : number,
  Name : string,
  Description: string,
}

export interface IProcessOutputLocation extends IEntityBase,IAuditableEntity {
  Id? : number,
  LocationTypeId :number | null,
  ValueId :number | null ,
  LocationName :string,
  Quantity : number | null,
  UnitOfMeasureId :number | null
}

export type MXChip = {
  Temperature: number,
  Pressure: number,
  Humidity: number,
  $ts: Date,
  AccelerometerX: number;
  AccelerometerY: number;
  AccelerometerZ: number;
}

export interface IProductionDetailFilter  {
  JobNumber : string,
  OrderNumber : string,
  WorkStationId: number | any,
  OperationId: number | any,
  PartId: number | any,
  JobStatus : number | any
}

export interface IProductionDetail {
  Id? : number,
  ScheduleJobId : number | any,
  OrderId : number | any,
  WorkStationId: number | any,
  OperationId: number | any,
  StartTime : Date | any,
  EndTime : Date | any,
  JobStatus : number | any
}

export interface IMaintenanceFilter {
  ResourceId: number | null,
  ChecksheetId: number | null,
  MaintenanceById: number | null,
  MaintenanceStatusId: number | null,
  Date: number | null,
}

export interface IMaintenanceRecurrence {
  MaintenanceDTO: IMaintenanceDTO;
  RecurrenceRuleDTO: IRecurrenceRuleDTO | null;
  RecurrenceWeekDayDTO: IRecurrenceWeekDayDTO[];
}

/* ================= Maintenance ================= */

export interface IMaintenanceDTO {
  Id: number;
  MaintenanceById: number;
  MaintenanceTypeId: number;
  MaintenanceDate: Date | string | null;
  StartDate: Date | string;
  EndDate: Date | string;
  StartTime:  Date | any;
  EndTime: Date | any;
  DownTimeDuration: string | null;
  ResourceId: number;
  ChecksheetId: number;
  MaintenanceStatusId: number;
  Remarks: string | null;
}

/* ================= Recurrence Rule ================= */

export interface IRecurrenceRuleDTO {
  Id: number;
  IntervalValue: number;
  StartDate: Date | string;
  EndDate: Date | string | null;
  StartTime?: string | Date | null;
  EndTime?: string | Date | null;
  DayOfMonth: number | null;
  WeekOfMonth: number | null;
  DayOfWeekId: number | null;
  MonthOfYear: number | null;
  FrequencyTypeId: number | null;
}

/* ================= Recurrence Week Day ================= */

export interface IRecurrenceWeekDayDTO {
  Id: number;
  RecurrenceRuleId: number | null;
  DayOfWeekId: number | null;
}


export interface IMaintenance extends IEntityBase, IAuditableEntity {
  ResourceId: number | null,
    ChecksheetId: number | null,
    MaintenanceDate: Date | any,
    StartDate : Date | any,
    EndDate : Date | any,
    MaintenanceById: number | null,
    MaintenanceTypeId: number | null,
    DownTimeBreakdown: string,
    MaintenanceStatusId: number | null,
    Remarks: string
}

export interface IMaintenanceTypeFilter {  
  Name : string,  
}

export interface IMaintenanceType extends IEntityBase, IAuditableEntity { 
  Name : string, 
  Description: string 
}

export type DateRange = { startDate: any; endDate: any };

export interface IProductionOrderFilter {
  OrderId : number | null,
  ServiceOrderId : number | null,
  PartNumber : string | null,
  ProductionOrderStatusId : number | null,
  ProductionOrderNumber : string | null,
  AssignedToId : number | null,
  startDate?: Date | null,
}

export interface IProductionOrderStatusFilter  {
  Name: string
}

export interface IDownTimeCodeFilter  {
  Name: string
}

export interface IProductionOrderStatus {
  Id? : number,
  Name : string,
  Description : string,
}

export interface IDownTimeCode {
  Id? : number,
  Name : string,
  Description : string,
  IsEnabled : false,
  WorkStationStatusId: number | null,
  ProductionLossCategory: number | null
}

export interface IProductionOrder {
  Id? : number,
  OrderId? : number | null,
  ServiceOrderId? : number | null,
  PartId? : number | null,
  ProductionOrderStatusId : number,
  ProductionOrderNumber : string,
  AssignedToId? : number | null,
  StartTime : Date | any,
  EndTime : Date | any,
  Quantity? : number | null,
  UnitOfMeasureId? : number | null,
  Remarks : string,
  ProductionPlanId : number | null,
  WorkStationId: number | null,
  ProductionOrderTypeId: number | null,
  CustomerId: number | null
  IsAutoDeductInventory: boolean | null
  ProjectId: number | null
}

export interface IProductionOrderLine {
  Id? : number,
  PartId : number | null,
  ProductionOrderId : number | null,
  Quantity : number | null,
  UnitOfMeasureId : number | null,
  Remark : string,
}

export interface IProductionLineNumber {
  id? : number,
  PartId? : number | null,
  Quantity? : number | null,
  UnitOfMeasureId? : number | null
  scheduleJobId? : number | null,
  ProductionOrderId? : number | null,
}

export interface ISerialNumberConfigurationFilter {
  Id: number | null
}

export interface ISerialNumberConfiguration extends IEntityBase, IAuditableEntity{
  Name: string,
  Description: string,
}

export interface IPartCategorySerialConfiguration extends IEntityBase, IAuditableEntity {
  PartCategoryId : number | null,
  SerialNumberConfigurationId : number | null,
}

export interface IPartSerialConfiguration extends IEntityBase, IAuditableEntity {
  PartId : number | null,
  SerialNumberConfigurationId : number | null,
}

export interface ISerialNumberDetail extends IEntityBase, IAuditableEntity {
  Id? : number,
  SerialNumberConfigurationId : number | null,
  SerialNumberId : number | null,
  Value : string | null,
}

export interface ISerialNumberFilter {
  SerialNumberValue: string,
  BatchNumber: string,
  PartId: number | null,
  GeneratedDate: Date | any,
}

export interface IProductionLineNumberFilter {
  ProductionLineNumberValue: string,
  BatchNumber: string,
  PartId: number | null,
  GeneratedDate: Date | any,
  ProductionOrderId: number | null
}

export interface IAssignSerialNumberFormData extends IEntityBase, IAuditableEntity {
  Id? : number,
  SerialNumberId : number | null,
  PartId: number | null
}

export interface IDownTimeData {
  Id? : number,
  WorkStationId: number | null,
  DeviceNumber: string,
  // ReadTime: Date | any,
  ShiftName: string,
  ShiftId: number | null,
  PartId: number | null,
  JobId: number | null,
  StepId: number | null,
  DownTimeCodeId: number | null,
  DownTimeCode: string,
  // StartTime: Date | any,
  // StopTime: Date | any,
}

export const ProductionLossCategoryLabels: Record<number, string> = {
  1: 'Availability Loss',
  2: 'Performance Loss',
  3: 'Quality Loss'
};


export interface IMachineUtilityDashboard {
  StartDate: Date | null,
  EndDate: Date | null,
  WorkStationIds: Array<number> | null,
  WorkStationGroupIds: Array<number> | null,
}

export interface GroupSummary {
  group: string;
  Target: number;
  Scheduled: number;
  Performance: number;
}

export enum ProcessRoutingStepsType{
  Production = 1,
  QC = 2,
  JobRequest = 3
}

export enum QCRecordStatus{
    Ok = 1,
    NotOk = 2,
    Rework = 3,
    Reject = 4
}




export interface QCApprovalResponseDto {
  ChecksheetDescription: string;
  ChecksheetId: number;
  ChecksheetName: string;
  ChecksheetStepRows: ChecksheetStepRowDto[];
  JobExecutionId: number;
  JobId: number;
  ProcessRoutingStepId: number;
  ProductionLineColumns: ProductionLineColumnDto[];
}

export interface ProductionLineColumnDto {
  JobExecutionQualityId: number;
  ProductionLineNumberId: number;
  ProductionLineNumber: string;
  ColumnOrder: number;
  IsSuccess: boolean;
  CreatedDate: string;
  CreatedBy: string;
  IsApproved: boolean;
  ApprovedBy: string | null;
  ApprovedDate: Date | null;
}

export interface ChecksheetStepRowDto {
  ChecksheetStepId: number;
  Name: string;
  Description: string;
  Instructions: string;
  MinimumValue: number | null;
  MaximumValue: number | null;
  UnitOfMeasure: string | null;
  IsMandatory: boolean;
  PriorityOrder: number;
  ControlMethodId: string | null;
  ProductionLineValues: { [key: string]: QCStepValueDto };
  QualityCheckStatusEnumId?: number | null;
}

export interface QCStepValueDto {
  JobExecutionQualityStepId: number | null;
  JobExecutionQualityId: number;
  ChecksheetStepId: number;
  Value: string;
  IsSuccess: boolean;
  Remarks: string;
  QualityCheckStatusEnumId: number | null;
}
export interface ProcessRoutingStepInputProperty{
  Id?: number | null;
  ProcessRoutingStepId: number;
  PartId: number;
  Quantity: number;
  UnitOfMeasureId: number;
}

export interface ICreateRejectPLN {
  QcJobId : number;
  ChecksheetStepId? : number; // Optional for reject
  ProductionLineNumberIds : [number];
  RejectionReason : string;
  RejectionLocationId : number;
}

export interface ICreateReworkPLN {
  JobExecutionQualityStepId? : number | null;
  ProductionLineNumberIds : number[];
  ChecksheetStepId : number; // MANDATORY for rework - backend needs this to find rework steps
  QcJobId : number;
}